import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

const theme = createMuiTheme({
  typography: {
    // 中文字符和日文字符通常比较大，
    // 所以选用一个略小的 fontsize 会比较合适。
    fontSize: 12,
    // 告知 Material-UI 此 html 元素的具体字体大小。
    htmlFontSize: 10,
  },
  palette: {
    type: "dark",
    primary: blue,
  },
});

export default theme
